import React from 'react';

import {
  convertLocationParamsToFetchParams,
  useObjectActivity,
} from 'app/activity/api';
import {GenericHookPaginatedList} from 'app/components/general/lists/GenericHookPaginatedList';
import {gt} from 'app/utils/i18n';

import {ActivityItem} from './ActivityItem';

import type {
  ActivityFetchParamsType,
  ActivityLocationParamsType,
  ActivityType,
} from 'app/activity/types/activity';
import type {WithRouterProps} from 'react-router';

export const ActivityList = (routerProps: WithRouterProps) => {
  return (
    <GenericHookPaginatedList<
      ActivityType,
      ActivityLocationParamsType,
      ActivityFetchParamsType
    >
      {...routerProps}
      useDataHook={useObjectActivity}
      hookParams={{
        actor: routerProps.params.userid,
      }}
      convertParamsFunc={convertLocationParamsToFetchParams}
      renderItem={(activity) => (
        <ActivityItem object={activity} key={activity.id} />
      )}
      messages={{
        notFound: ({NoResultsMessage}) => (
          <NoResultsMessage
            head={gt("This member hasn't generated any activity.")}
            icon="fas fa-user-clock"
          />
        ),
      }}
    />
  );
};
